import AbstractFormulaNode from "./AbstractFormulaNode.js";

/**
 * `keyFigureFormulaNode` is a concrete implementation
 * of `abstractFormulaNode` representing a keyFigure.
 *
 * It is mainly a name.
 *
 * @param {string} type - type of key figure value
 * @param {keyFigure} keyFigure - KeyFigure represented by the formula node
 * @param {boolean} visible - True if the keyfigure is visible, false otherwise
 */
export default class KeyFigureFormulaNode extends AbstractFormulaNode {
	constructor({ type, keyFigure, visible } = {}) {
		super(...arguments);

		this._type = type;
		this._keyFigure = keyFigure;
		this._visible = visible;
	}

	getType() {
		return this._type;
	}

	getValueType() {
		return this._type;
	}

	getKeyFigure() {
		return this._keyFigure;
	}

	isVisible() {
		return this._visible;
	}

	isLeaf() {
		return true;
	}

	isKeyFigureFormulaNode() {
		return true;
	}

	accept(visitor, additionalInformation) {
		return visitor.visitKeyFigureNode(this, additionalInformation);
	}

	_serializedProperties() {
		const properties = super._serializedProperties();

		properties.valueType = this._type;
		properties.id = this._keyFigure.getId();
		properties.visible = this._visible;

		return properties;
	}

	static getType() {
		return "KeyFigureReferenceNode";
	}

	static transformMaterializationData(data, context) {
		super.transformMaterializationData(...arguments);

		// We can not use `context.keyFigures` in the case where
		// we are in the process of materializing keyFigures
		// as we can not provide all keyFigures in the context.
		// Instead, we use `getKeyFigureFromCache` as a late-bound
		// solution.
		const matchingKeyFigure =
			context.keyFigures?.[data.id] ||
			context.getKeyFigureFromCache?.(data.id);

		if (!matchingKeyFigure) {
			throw `No keyFigure found for id: ${data.id}`;
		}

		data.type = matchingKeyFigure.getValueType();
		data.keyFigure = matchingKeyFigure;
		data.visible = matchingKeyFigure.isVisible();
	}
}
